export default class TreeObject {
    constructor(item) {
        if (item) {
            for (const key in item) {
                if (item.hasOwnProperty(key)) {
                    this[key] = item[key];
                }
            }
        }
    }

    static searchConfig = [{
        'icon': 'mdi-format-text',
        'label': 'Naam',
        'type': 'property',
        'settings': {
            'fields': ['name'],
            'title': '{name}',
        },
        'filter': 'tree_objects_view.name'
    },
    {
        'icon': 'mdi-file-sign',
        'label': 'Type',
        'type': 'module',
        'settings': {
            'module': 'productTypes',
            'fields': ['name'],
            'title': '{name}',
        },

        'filter': 'tree_objects_view.type_id'
    }]

    static icons = {
        PROJECT: 'mdi-folder-open-outline',
        COMPANY: 'mdi-office-building-outline',
        ARTICLE: 'mdi-package-variant',
        TOOL: 'mdi-tools',
        DEVICE: 'mdi-cube-outline',
        DEVICE_FOLDER: 'mdi-folder-open',
        TOOL_FOLDER: 'mdi-folder-open',
        ARTICLE_FOLDER: 'mdi-folder-open',
        TEMPLATE_ALARM: 'mdi-bell-alert-outline',
        DEPOT: 'mdi-warehouse',
        TASK: 'mdi-clipboard-outline'
    };

    static getIcon(value) {
        return this.icons[value] || null;
    }
}